import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ProductGrid from './ProductGrid';

import '../Loader.css';

const HomeProduct = () => {
    let apiUrl = '/';

  if(process.env.REACT_APP_ENVIRONMENT == 'local'){
       apiUrl = process.env.REACT_APP_SERVER_API_URL;
  }

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${apiUrl}api/product/getproducts`);
                if (response.status !== 200) {
                    throw new Error('Failed to fetch products');
                }

                const data = Array.isArray(response.data) ? response.data : [];
                setProducts(data);
            } catch (err) {
                console.error('API error:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [apiUrl]);

    return (
        <div className="product-section" style={{ marginTop: "50px", marginBottom: "50px" }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 text-center">
                        <div className="section-title" id="product_section">
                            <h3><span className="orange-text">Our</span> Products</h3>
                            <p>Explore our products and discover the latest trends in men's and women's clothing</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                {loading && (
                        <div className="loader-container">
                            <div className="loader"></div>
                        </div>
                    )}
                    {error && <p>Error: {error}</p>}
                    {Array.isArray(products) && products.map((product) => (
                        <ProductGrid key={product._id} data={product} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HomeProduct;
